export default "__VITE_ASSET__IF43S40y__"